import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login'
import store from '../store'
//import temp from '../views/temp'

import admin from "./admin";
import organ from "./organ";
import college from "./college";
import student from "./student";
import expert from "./expert";

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Login',
        component: Login
    },
    {
        path: '/regist',
        name: 'Regist',
        component: () => import(/* webpackChunkName: "regist" */ '../views/StudentRegist')
    },
    {
        path: '/error',
        name: 'Error',
        component: () => import(/* webpackChunkName: "error" */ '../views/Error')
    },
    {
        path: '/pdfView/:attFileId',
        name: 'pdfView',
        component: () => import(/* webpackChunkName: "pdfView" */ '../views/PdfView')
    },
    {
        path: '/validateCertificate/:studentClassId',
        name: 'validateCertificate',
        component: () => import(/* webpackChunkName: "validateCertificate" */ '../views/ValidateCertificate')
    },
    {
        path: '/messageManage',
        name: 'UserMessageManage',
        component: () => import(/* webpackChunkName: "user-message-manage" */ '../views/UserMessageManage')
    },
    {
        path: '/forget',
        name: 'Forget',
        component: () => import(/* webpackChunkName: "StudentForget" */ '../views/student/StudentForget')
    },
    admin,
    organ,
    college,
    student,
    expert,
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

router.beforeEach(function (to, from, next) {
    let userType;
    let userInfo;

    // 0 - 未登录需要跳转；1-未登录不需要跳转；2- 已登录
    let state = 0;

    if (store.loginState) {
        // state中保存的数据
        userType = store.state.userType;
        userInfo = store.state.userInfo;

        state = 2;
    } else {
        // state中没有保存数据，在sessionstorage中想找
        let userTypeData = sessionStorage.getItem("userType");
        let userInfoData = sessionStorage.getItem("userInfo");

        if (userTypeData && userInfoData) {
            // storage中有用户数据
            userType = Number(userTypeData);
            userInfo = JSON.parse(String(userInfoData));

            store.commit('loginMutation', {userType, userInfo});
            state = 2;
        } else {
            // storage中也没有数据，则跳转到登录页面
            if (to.fullPath === '/' || to.fullPath === '/regist' || to.fullPath === '/forget' || to.fullPath.startsWith('/validateCertificate') || to.fullPath.startsWith('/pdfView')) {
                state = 1;
            } else {
                state = 0;
            }
        }
    }

    if (state === 0) {
        next('/');
    } else if (state === 1) {
        next();
    } else {
        if (to.fullPath.startsWith('/admin') && userType !== 1) {
            next('/error');
        } else if (to.fullPath.startsWith('/organ') && userType !== 2) {
            next('/error');
        } else if (to.fullPath.startsWith('/college') && userType !== 3) {
            next('/error');
        } else if (to.fullPath.startsWith('/student') && userType !== 4) {
            next('/error');
        } else if (to.fullPath.startsWith('/expert') && userType !== 5) {
            next('/error');
        } else {
            next();
        }
    }

});

export default router
